module.exports = __webpack_public_path__ + "static/media/sqlite_logo.8da2bae4.png";